if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
const updateMediaFromSelectedVariant = () => {


  const checkedInput = this.closest('section')?.querySelector(
    'input[type="radio"]:checked, select'
  );


  if (!checkedInput) return;

  const selectedValue = (checkedInput.value || '').trim().toLowerCase();
  

  if (!selectedValue) return;

  requestAnimationFrame(() => {
    this.setActiveMediaByAlt(selectedValue);
  });
};

this.closest('section').addEventListener('change', updateMediaFromSelectedVariant);

this.closest('section').addEventListener('click', (event) => {
  if (event.target.closest('label')) {
    setTimeout(updateMediaFromSelectedVariant, 50);
  }
});
}
   
      

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }



        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
      setActiveMediaByAlt(selectedValue) {

  const mediaItems = Array.from(
    this.elements.viewer.querySelectorAll('[data-media-id][data-media-alt]')
  );

  const matchedMedia = [];
  for (const item of mediaItems) {
    const alt = (item.dataset.mediaAlt || '').trim().toLowerCase();
    if (alt.startsWith(selectedValue)) matchedMedia.push(item);
  }

if (!matchedMedia.length) return false;

  matchedMedia.sort((a, b) => {
  const altA = (a.dataset.mediaAlt || '').trim().toLowerCase();
  const altB = (b.dataset.mediaAlt || '').trim().toLowerCase();

  const rank = (alt) => {
    if (alt.includes('lifestyle')) return 1;
    if (alt.includes('product')) return 2;
    if (alt.includes('texture')) return 3;
    return 4;
  };

  return rank(altA) - rank(altB);
});

  const matchedIds = matchedMedia.map((item) => item.dataset.mediaId);
  const viewerContainer = matchedMedia[0].parentElement;

  const alreadyGrouped = matchedMedia.every((item, index) => {
    return viewerContainer.children[index] === item;
  });

  if (!alreadyGrouped) {

    matchedMedia.slice().reverse().forEach((item) => {
      viewerContainer.prepend(item);
    });

    if (this.elements.viewer.slider) {
      this.elements.viewer.resetPages();
    }

    if (this.elements.thumbnails) {

      const thumbnails = Array.from(
        this.elements.thumbnails.querySelectorAll('[data-target]')
      );

      const matchedThumbs = thumbnails.filter((thumb) =>
        matchedIds.includes(thumb.dataset.target)
      );

      if (matchedThumbs.length) {
        if (matchedThumbs.length) {

  // 👇 ADD THIS BLOCK HERE (NEW)
  matchedThumbs.sort((a, b) => {
    const targetA = a.dataset.target;
    const targetB = b.dataset.target;

    const mediaA = matchedMedia.find((item) => item.dataset.mediaId === targetA);
    const mediaB = matchedMedia.find((item) => item.dataset.mediaId === targetB);

    const altA = ((mediaA && mediaA.dataset.mediaAlt) || '').trim().toLowerCase();
    const altB = ((mediaB && mediaB.dataset.mediaAlt) || '').trim().toLowerCase();

    const rank = (alt) => {
      if (alt.includes('lifestyle')) return 1;
      if (alt.includes('product')) return 2;
      if (alt.includes('texture')) return 3;
      return 4;
    };

    return rank(altA) - rank(altB);
  });

  // 👇 KEEP THIS (DO NOT DELETE)
  const thumbContainer = matchedThumbs[0].parentElement;

  const thumbsAlreadyGrouped = matchedThumbs.every((thumb, index) => {
    return thumbContainer.children[index] === thumb;
  });

  if (!thumbsAlreadyGrouped) {
    matchedThumbs.slice().reverse().forEach((thumb) => {
      thumbContainer.prepend(thumb);
    });
  }
}

        const thumbContainer = matchedThumbs[0].parentElement;

        const thumbsAlreadyGrouped = matchedThumbs.every((thumb, index) => {
          return thumbContainer.children[index] === thumb;
        });

        if (!thumbsAlreadyGrouped) {
          matchedThumbs.slice().reverse().forEach((thumb) => {
            thumbContainer.prepend(thumb);
          });
        }

      }
    }
  }

  const firstMediaId = matchedIds[0];
  this.setActiveMedia(firstMediaId, false);

  if (this.elements.thumbnails) {
    const firstThumb = this.elements.thumbnails.querySelector(
      `[data-target="${firstMediaId}"]`
    );
    if (firstThumb) this.setActiveThumbnail(firstThumb);
  }

}

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
      //  window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
